export const it = {
  // Navigazione
  home: "Home",
  cart: "Carrello",
  checkout: "Pagamento",
  profile: "Profilo",
  search: "Cerca",

  // Elenco prodotti
  addToCart: "Aggiungi al carrello",
  updateCart: "Aggiorna il carrello",
  buyNow: "Acquista subito",
  price: "Prezzo",
  allProducts: "Tutti i prodotti",
  featuredItems: "Prodotti in evidenza",
  specialOffers: "Offerte speciali",
  categories: "Categorie",
  allCategories: "Tutte le categorie",
  viewAll: "Mostra tutto",
  youMightAlsoLike: "Potrebbe interessarti anche",
  reviews: "Recensioni",
  exploreServices: "Scopri i servizi",
  viewOffer: "Vedi l'offerta",
  details: "Dettagli",
  products: "Prodotti e servizi",
  item: "elemento",
  items: "elementi",

  // Ricerca
  searchForProducts: "Cerca prodotti o servizi",
  recentSearches: "Ricerche recenti",
  noProductsFound: "Nessun prodotto trovato",

  // Carrello
  yourCart: "Il tuo carrello",
  emptyCart: "Il carrello è vuoto",
  continueShopping: "Continua a fare acquisti",
  removeItem: "Rimuovi",
  quantity: "Quantità",
  total: "Totale",
  subtotal: "Costi del servizio",
  proceedToCheckout: "Procedi al pagamento",
  browseServices: "Esplora i nostri servizi",

  // Pagamento
  paymentDetails: "Dati di pagamento",
  cardNumber: "Numero di carta",
  cardholderName: "Intestatario della carta",
  expiryDate: "Scadenza",
  cvv: "CVV",
  billingAddress: "Indirizzo di fatturazione",
  placeOrder: "Conferma ordine",
  processing: "Elaborazione in corso...",
  creditCard: "Carta di credito",
  quickCheckout: "Pagamento veloce",
  payOnDeliveryDesc: "Paga in contanti o con carta alla consegna",
  continueWithPaypal: "Continua con PayPal",
  connectPaypal: "Collega PayPal",
  continueWithApplePay: "Continua con Apple Pay",
  connectApplePay: "Collega Apple Pay",
  orderSummary: "Riepilogo dell’ordine",
  paymentMethod: "Metodo di pagamento",
  cardDetails: "Dati carta",
  pay: "Paga",
  currency: "€",
  fullName: "Nome e cognome",
  email: "Email",
  phone: "Numero di telefono",
  deliveryAddress: "Indirizzo di consegna",
  nameRequired: "Il nome è obbligatorio",
  validEmailRequired: "Inserisci un'email valida",
  phoneRequired: "Il numero di telefono è obbligatorio",
  addressRequired: "L’indirizzo di consegna è obbligatorio",
  completeYourOrder: "Complete your order quickly with card payment",
  payWithCard: "Pay with card",

  // Conferma
  orderConfirmed: "Ordine confermato!",
  thankYou: "Grazie per il tuo acquisto",
  orderNumber: "Numero d’ordine",
  summaryTitle: "Dettagli dell’ordine",
  backToShopping: "Torna ai prodotti",
  backToHome: "Torna alla home",

  // Errori
  pageNotFound: "Pagina non trovata",
  returnHome: "Torna alla home",

  // Lingua
  language: "Lingua",
  english: "Inglese",
  spanish: "Spagnolo",
  italian: "Italiano",

  // Hotel
  welcomeMessage: "Benvenuto presso",

  // Varie
  loading: "Caricamento in corso...",
  error: "Si è verificato un errore",
  retry: "Riprova",
  close: "Chiudi",

  noProductsAvailable: "Nessun prodotto disponibile",
  noProductsInCategory: "Nessun prodotto in questa categoria",
};
